import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import { useHistory, useLocation } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { formatDateG, formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import { Auth, API } from "aws-amplify";
import { onError } from "../libs/errorLib";
import "./Admin.css";
import "../admin.css";

const AdminMailComplete = ({backFromMail})  => {
  const backFromMail0 = (e) => {
    console.log('aaa');
  }
  const getFormatDate = (t) => {
    const d = new Date(t);
    return formatDateG(d, 'yyyy/MM/dd HH:mm');
  };
  return (

        <section id="contents">
          <h2>メール送信完了</h2>
          <div id="create_mail">
            <p>メールを送信しました。</p>
          </div>
          <div className="opBtns">
            <Button id="backToList" active size="lg" active onClick={ backFromMail } >
          一覧へ戻る
            </Button>
          </div>
      </section>
  );
}

export default AdminMailComplete;
